var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('admin-title',{attrs:{"title":_vm.$route.meta.name}}),_c('tp-table',{attrs:{"tableData":_vm.list,"columns":_vm.columns,"isPage":0}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }